<i18n>
{
  "en": {
    "signInButtonText": "Sign In"
  },
  "th": {
    "signInButtonText": "เข้าสู่ระบบ"
  }
}
</i18n>
<template>
  <v-btn
    text
    class="blue--text "
    v-if="!user && !preventButton"
    @click="goLogin()"
  >
    {{ $t('signInButtonText') }}
  </v-btn>
</template>

<script>
import helpers from '../mixins/helpers'

export default {
  name: 'PaowSignInButton',
  mixins: [helpers],
  props: {
    user: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    preventButton () {
      return this.currentPage === 'login' || this.currentPage === 'permission'
    }
  },
  methods: {
    goLogin () {
      if (!this.user) {
        this.navigateTo('login')
      }
    }
  }
}
</script>

<style scoped>

</style>
